import type { LayoutContext, TitleProps } from "./_types";

import { useMemo, useState } from "react";

/** useHooks */
export const useHooks = () => {
  /** title */
  const [title, setTitle] = useState<TitleProps>();

  /** loading */
  const [loading, setLoading] = useState(false);

  /** return */
  return useMemo(
    (): LayoutContext => ({
      title,
      loading,
      setTitle,
      setLoading,
    }),
    [loading, title]
  );
};
